import { createContext, useContext, useSyncExternalStore, type ReactNode } from "react";
import type { AppRealtimeSnapshot, AppRealtimeStore } from "./app-store.js";

const AppRealtimeContext = createContext<AppRealtimeStore | null>(null);

export type AppRealtimeProviderProps = {
  readonly store: AppRealtimeStore;
  readonly children: ReactNode;
};

export function AppRealtimeProvider({ store, children }: AppRealtimeProviderProps) {
  return <AppRealtimeContext.Provider value={store}>{children}</AppRealtimeContext.Provider>;
}

export function useAppRealtimeStore(): AppRealtimeStore {
  const store = useContext(AppRealtimeContext);
  if (store === null) throw new Error("useAppRealtimeStore must be used within AppRealtimeProvider");
  return store;
}

export function useAppRealtimeSnapshot(): AppRealtimeSnapshot {
  const store = useAppRealtimeStore();
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
